import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { InfoTip } from '@molecules'
import { arrayUtils, objectUtils } from '@utils'
import { COMMON } from '@constants'

function Checkbox({
  name,
  label,
  value,
  canEdit,
  checked,
  infoTip,
  onChange,
  componentName,
  indeterminate,
  ...props
}) {
  const isChecked = checked == null ? !!value : checked
  const validHTMLElementProps = useMemo(() => {
    const propKeys = Object.keys(props)
    const validKeys = arrayUtils.intersectBy(propKeys, COMMON.HTML_ATTRIBUTES.GLOBAL.concat(COMMON.HTML_ATTRIBUTES.INPUT), (x) => x.toLowerCase())
    return objectUtils.pick(props, validKeys)
  }, [props])

  return (
    <div className="checkbox__container">
      <input
        {...validHTMLElementProps}
        id={name}
        name={name}
        type="checkbox"
        onChange={onChange}
        className={`checkbox${indeterminate ? '--indeterminate' : ''}`}
        checked={isChecked}
      />
      <label
        className={`checkbox-animation${indeterminate ? '--indeterminate' : ''}`}
        htmlFor={name}
      >
      </label>
      {label
        && <label {...validHTMLElementProps} className="cursor-pointer" htmlFor={name} >
          <span className="subtext">
            {label}
          </span>
        </label>
      }
      {infoTip ? <InfoTip name={name}>{infoTip}</InfoTip> : null}
    </div>
  )
}

Checkbox.propTypes = {
  value: PropTypes.bool,
  name: PropTypes.string,
  canEdit: PropTypes.bool,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  infoTip: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object]),
  indeterminate: PropTypes.bool,
  componentName: PropTypes.string
}

Checkbox.defaultProps = {
  name: '',
  label: '',
  disabled: false,
  indeterminate: false
}

export default Checkbox
